export default {
    methods: {
        //This method defines whether an action is allowed according to an array of valid options.
        can(actions, name) {
            if(name == 'get'){
                return true;
            }
            if (actions && actions.length > 0 && actions.indexOf(name) >= 0) {
                return true;
            }
            return false;

        }
    }
}